
















































import { defineComponent } from '@vue/composition-api'
import { mask } from 'vue-the-mask'
import { crudEditMixin } from '@/utils/mixins/crudEditMixin'
import { announcementController, getAgencies } from '@/api/Agency/agency.api'
import CreateDialog from './CreateDialog.vue'
import Autocomplete from './Autocomplete.vue'
import vRules from '@/utils/vRules'
import store from '@/store'
import DatePicker from './DatePicker.vue'
import moment from 'moment'

export default defineComponent({
  components: { CreateDialog, Autocomplete, DatePicker },
  directives: { mask },
  mixins: [
    crudEditMixin(
      {
        title: '',
        body: '',
        start_date: new Date().toISOString().substring(0, 10),
        end_date: new Date().toISOString().substring(0, 10),
        agency: store.state.profile?.agency,
      },
      announcementController.createOrUpdateJson,
    ),
  ],
  data() {
    return {
      vRules,
      getAgencies,
      moment,
    }
  },
})
